import { Variant } from '../../types/product';

const updateVariantAvailability = (variantsData: Variant[], variantsContainer: HTMLElement): void => {
  // Get all variant options inputs from the container
  const optionInputEls: HTMLInputElement[] = Array.from(variantsContainer.querySelectorAll<HTMLInputElement>('[data-product-variants-input]'));

  // Collect all unique option group names, e.g., "Size" or "Color"
  const optionGroupNames: string[] = optionInputEls
    // Convert NodeList to an array and map each input to its group name
    .map((input: HTMLInputElement): string => input.name)
    // Filter out duplicates, keeping only unique group names
    .filter((name: string, index: number, array: string[]): boolean =>
      // array.indexOf(name) returns the index of the first occurrence of this name
      // If this first occurrence index matches the current index in filter, it's the first time we see it therfore we should keep it
      array.indexOf(name) === index
    );

  // Collect the currently selected values for each option group (or null if nothing is selected)
  const selectedValues: (string | null)[] = optionGroupNames.map((groupName): string | null => {
    const selectedInput = variantsContainer.querySelector<HTMLInputElement>(`[data-product-variants-input][name="${groupName}"]:checked`);
    return selectedInput ? selectedInput.value : null;
  });

  // For each input, decide whether it should be enabled or disabled
  optionInputEls.forEach((input: HTMLInputElement): void => {
    const groupIndex: number = optionGroupNames.indexOf(input.name);

    // Disable the input if no available variant matches with the current selection + this input's value
    input.disabled = !variantsData.some((variant: Variant): boolean =>
      variant.available &&                                   // Only consider available variants
      variant.options[groupIndex] === input.value &&         // Variant must match this input's value
      selectedValues.every((value: string | null, optionIndex: number): boolean =>   // Check compatibility with other selected options
        value === null || optionIndex === groupIndex || variant.options[optionIndex] === value
      )
    );
  });
};

export default updateVariantAvailability;
